import React from 'react';
import styled from "react-emotion";


const Container = styled.div( props => `
  text-align: ${props.align || 'left'};
  margin-top: 1rem;

  & > *{
    margin-top: 2rem;
    
    @media (min-width: 767px) {
      margin-top: 0;
      margin-right: 1rem;
    }
  }
`)

const CalloutContainer = (props) => {
  return (
    <Container {...props}>{props.children}</Container>
  );
}
 
export default CalloutContainer;


// WEBPACK FOOTER //
// ./src/components/CalloutContainer.js